import type { HTMLAttributes, ReactNode } from 'react'
import { Eyebrow } from './Eyebrow'
import styles from './Panel.module.css'

export type PanelPadding = 'sm' | 'md' | 'lg' | 'flush'
export type PanelTone = 'default' | 'active' | 'danger' | 'muted'

export interface PanelProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  /* Optional caption row above the content. */
  title?: ReactNode
  /* Controls rendered on the right of the title row. */
  actions?: ReactNode
  padding?: PanelPadding
  align?: 'left' | 'center'
  tone?: PanelTone
  as?: 'div' | 'section' | 'aside'
  children?: ReactNode
}

const toneClass: Record<PanelTone, string | undefined> = {
  default: undefined,
  active: styles.toneActive,
  danger: styles.toneDanger,
  muted: styles.toneMuted,
}

export function Panel({
  title, actions, padding = 'md', align = 'left', tone = 'default', as: Tag = 'div',
  className, children, ...rest
}: PanelProps) {
  const cls = [
    styles.panel,
    styles[padding],
    align === 'center' && styles.alignCenter,
    toneClass[tone],
    className,
  ].filter(Boolean).join(' ')

  return (
    <Tag className={cls} {...rest}>
      {(title || actions) && (
        <div className={styles.head}>
          {title && (typeof title === 'string' ? <Eyebrow>{title}</Eyebrow> : title)}
          {actions}
        </div>
      )}
      {children}
    </Tag>
  )
}
